import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark} from "@fortawesome/pro-solid-svg-icons";
import {faChevronDown} from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import React from "react";
import {FilterInputType} from "../../Types/FormTypes";

const FilterInput = (props: FilterInputType) => {
    const HandleReset = (e: any) => {
        props.resetCallback(e);
        setTimeout(() => {
            props.inputRef.current.focus();
        }, 90);
    }

    return (
        <div className={`select-wrapper ${props.filterValue !== '' && props.active ? 'select-wrapper-icon': ''}`}>
            <input
                ref={props.inputRef}
                onBlur={(e) => props.blurCallback(e)}
                onChange={(text) => props.filterCallback(text)}
                placeholder={props.placeholder ?? 'Filter...'}
                autoComplete={'off'}
                spellCheck={false}
                onKeyDown={(e) => props.filterNavigationCallback(e)}
                onFocus={(e) => props.filterFocusCallback(e)}
                className={'m-0'}
                aria-invalid={props.error !== null}
                disabled={props.isLoading}
                aria-autocomplete={'none'}
                type={'text'}
            />

            <div className={'select-wrapper-addon select-reset'} style={{ pointerEvents:!!props.filterValue && props.active ? 'auto' : 'none', opacity: !!props.filterValue && props.active ? 1 : 0 }} onMouseDown={(e) => HandleReset(e)}>
                <FontAwesomeIcon icon={faCircleXmark} />
            </div>

            {!props.listAlwaysVisible && !props.hideArrow && (
                <div className={'select-wrapper-addon select-wrapper-addon-end'}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>
            )}
        </div>
    )
}

export default FilterInput
